<template>
	<div :class="'freeUserTips free-usertips-bg' + bgtype">
		<div class="freeUserTips-opbg container-flex-center">
			<div class="freeUserTips-con">
				<h5 class="title tac orangefont fz24 lh48 mt-2">温馨提示</h5>
				<p class="tac fz16 lh28 orangefont" v-if="type == 1">您的试用时间已到期，如需延期请即刻与我们联系<br> 升级为正式账号，即可享受完整权益</p>
				<p class="tac fz16 lh28 orangefont" v-if="type == 2">升级为正式账号，即可享受完整权益</p>
				<p class="tac fz16 lh28 orangefont" v-if="type == 3">成为SVIP， 即可享受产业链分析报告下载功能</p>
				<!-- <p class="tac fz16 lh28 orangefont vip-link" v-if="type == 4" @click="routerblank('/order')">开通VIP，即可享受完整权益</p> -->

				<div v-if="type == 4" class="font-16 tips-content">
					<p class="redfont font-bold hover" @click="routerblank('/order')">立即开通VIP，即可使用完整功能 > </p>
					<p class=" font-bold hover" @click="isShowShiyong = true">先试用再决定购买，点击申请试用 > </p>
					<p class="">有问题,想咨询：<span class="hover" @click="openSmWindow('https://wpa1.qq.com/lwDa6cb4?_type=wpa&qidian=true')">在线客服 > </span></p>
					<p class="">电话咨询：<span>400 008 0586 </span> <span class="dil ml-2">0755-82571568
						</span></p>
					<p class="">微信咨询：</p>

				</div>
				<!-- 请 <a class="curp" href="https://wpa1.qq.com/4sai7BwX?_type=wpa&qidian=true"
						target="_blank">在线咨询 ></a> ，或微信咨询： -->
				<div class="right-slide-wechat mga por">
					<div class="wechatfont">扫一扫 加微信咨询我们</div>
					<div class="wechat_codebox fl">
						<img src="../../assets/images/zixuncode-lss.png">
						<p class="tac">中投顾问 - 刘姗姗</p>
					</div>
					<div class="wechat_codebox fr">
						<img src="../../assets/images/zixuncode-bl.png">
						<p class="tac">中投顾问 - 白灵</p>
					</div>
				</div>
				<div class="text-center fz16 mt-2 download-text hover" @click="routerblank('/chain?id=44')"
					v-show="isShowDownFile">点击查看参考样版：半导体产业链图谱 ></div>
				<div class="text-center fz16 mt-2 download-text hover"
					@click="routerblank('/enterprises-free?id=300750&type=9')" v-show="isEnterpirseDetail">点击查看样本企业 >
				</div>

				<div v-if="type != 4">
					<p class="tac fz16 orangefont mt-2">联系电话:400 008 0586&nbsp;&nbsp;&nbsp;&nbsp;0755-82571568</p>
					<!-- <p class="tac mt-1 download-text fz16" v-show="isShowDownFile">点击下载：<a class="fz16 basefont" href="https://lian.ocn.com.cn/upload/pdf/202403/291129249208772.docx" target="downloadFile" download>新能源汽车产业链分析报告 ></a></p> -->
					<div class="text-center cur-pointer fz16 mt-2 basefont" @click="isShowShiyong = true">点击申请试用 ></div>
				</div>

			</div>
			<el-dialog class="localChain" :modal-append-to-body="false" append-to-body title=""
				:visible.sync="isShowShiyong" width="650px" top="15vh">
				<shiyong @handerChrend="handerChrend"></shiyong>
			</el-dialog>

		</div>
	</div>
</template>

<script>
import shiyong from "@/components/inc/shiyong.vue"
import { is } from "core-js/core/object";

export default {
	name: 'userlogin',
	components: {
		shiyong,
	},
	props: {
		type: {
			type: Number,
			default: 1, //1试用账号 2免费账号 3正式账号但无操作权限
		},
		bgtype: {
			type: Number,
			default: 1,
			/*1为企业详情页供应商客户表格背景 2为拿地信息表格 3投资项目表格 4融资项目 5.对外投资 6.控制企业 7.专利信息8.软件著作权9.资质证书 10裁判文书 11司法案件 
			14为白色背景15.以商招商列表页 16.企业-城市关系计算器（本地关联企业）列表 17.企业-城市关系计算器（一级关系圈）列表 18.企业-城市关系计算器（二级关系圈计算结果）列表
			19.协会 20.商会 21.专业镇 22.股东信息 23.企业详情的相同投资机构 24.相同协会 25.相同商会 26.本地投资趋势 27.外商投资趋势 28.企业详情的企业画像（雷达图）
			29.企业详情经营状况 30.企业详情的股东信息 31.企业详情企业资质 32.企业详情研发信息 33.企业详情股权质押 34.企业详情风险预警 35.企业详情企业动态 36.投资机构详情投资领域
			37、投资机构详情投资画像 38.投资机构详情投资事件 39.企业详情产业标签 40.企业详情市场规模 41、产业链详情的市场规模 42、产业链详情的竞争格局 43、产业链详情的重点产业细分公司表格
			*/
		},
		isShowDownFile: {  //是否显示下载模板链接
			type: Boolean,
			default: false,
		},
		isEnterpirseDetail: { type: Boolean, default: false },
		isShowPageTitle: { type: String, default: '' },
	},
	data() {
		return {
			userdata: {},
			isShowShiyong: false,
		}
	},
	created() {
		this.userdata = this.getuseriformation();
	if(this.isShowPageTitle != ''){
			document.title = this.isShowPageTitle;
		}
	},
	methods: {
		//在线客服打开新窗口
		openSmWindow(url) {
			try {
				window.open(url, "_blank", "height=600,width=800,top=200,left=200,status=yes,toolbar=no,menubar=no,resizable=yes,scrollbars=no,location=no,titlebar=no");
				_hmt.push(['_trackEvent', '报告', '咨询', '在线客服'])
			} catch (e) { }
			return false;
		},
		handerChrend(falg) {
			this.isShowShiyong = falg;

		}
	}
}
</script>

<style>
 
.tips-content {
	line-height: 36px;
	width: 392px;
	margin: 0 auto;
}

.vip-link:hover {
	cursor: pointer;
	text-decoration: underline;
	color: #3A66BE;

}

.download-text {
	color: #3A66BE;
}

.download-text a {
	text-decoration: underline;
}

.freeUserTips {
	width: 100%;
	height: 545px;
}

/*free-usertips-bg 在leftnav.less 搜索free-usertips-bg*/
.freeUserTips-opbg {
	width: 100%;
	height: 100%;
	background: rgba(255, 255, 255, .8);
	overflow: hidden;
}

.freeUserTips-con {
	width: 641px;
	height: 515px;
	margin: 20px auto;
	background: #fff6e4;
	border: 4px solid #f2c86f;
	overflow: hidden;
}
</style>